import { render, staticRenderFns } from "./modelmanage.vue?vue&type=template&id=21905bff&scoped=true&"
import script from "./modelmanage.vue?vue&type=script&lang=js&"
export * from "./modelmanage.vue?vue&type=script&lang=js&"
import style0 from "./modelmanage.vue?vue&type=style&index=0&id=21905bff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21905bff",
  null
  
)

export default component.exports